import { render, staticRenderFns } from "./StartButton.vue?vue&type=template&id=7649c920&"
import script from "./StartButton.vue?vue&type=script&lang=js&"
export * from "./StartButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports